// tienda/PreciosSection.jsx
// Three pricing tier cards.

import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { brand, fadeUp } from "../shared/brand";

const PLANS = [
  { label: "1 envío",               price: "S/ 15",   sub: "Solo cuando necesitas",  popular: false },
  { label: "2+ envíos / día",       price: "S/ 9.90", sub: "Tienda estándar",        popular: true  },
  { label: "Provider (almacén FM)", price: "S/ 8.90", sub: "150+ envíos / semana",   popular: false },
];

export function PreciosSection() {
  return (
    <section id="precios" className="border-b border-slate-100 bg-slate-50 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2
          {...fadeUp}
          className="text-2xl font-extrabold text-center mb-2"
          style={{ color: brand.primary }}
        >
          Tarifas simples por entrega
        </motion.h2>
        <p className="text-sm text-slate-500 text-center mb-8">
          Sin costo de plataforma. Paga solo por entrega.
        </p>

        <div className="grid gap-4 sm:grid-cols-3 max-w-3xl mx-auto">
          {PLANS.map(plan => (
            <motion.div
              key={plan.label}
              {...fadeUp}
              className="relative rounded-2xl border bg-white p-5 text-center"
              style={
                plan.popular
                  ? { borderColor: brand.primary, boxShadow: `0 4px 20px ${brand.primary}20` }
                  : { borderColor: "#e2e8f0" }
              }
            >
              {plan.popular && (
                <div
                  className="absolute -top-2.5 left-1/2 -translate-x-1/2 rounded-full px-3 py-0.5 text-[10px] font-bold text-white whitespace-nowrap"
                  style={{ background: brand.primary }}
                >
                  Más popular
                </div>
              )}
              <div className="text-xs text-slate-500 mb-1">{plan.label}</div>
              <div className="text-2xl font-extrabold" style={{ color: brand.primary }}>{plan.price}</div>
              <div className="text-xs text-slate-400 mt-0.5 mb-4">{plan.sub}</div>
              <Link
                to="/register"
                className="block rounded-xl py-2 text-xs font-bold text-white"
                style={{ background: plan.popular ? brand.primary : "#64748b" }}
              >
                Crear cuenta
              </Link>
            </motion.div>
          ))}
        </div>

        <p className="mt-5 text-center text-xs text-slate-400">
          * Aplica en Lima Metropolitana y Callao. Para zonas especiales contáctanos.
        </p>
      </div>
    </section>
  );
}